// Middlebury College's majors (#2739). Read on 2026-10-01 from Middlebury's
// official Majors and Minors page (middlebury.edu/college/academics), which
// marks each area of study as a major, a minor or both: every area marked
// Major is kept, including the Independent Scholar major; minor-only areas
// are left out. Middlebury awards the bachelor of arts; the page gives no
// degree per major, so none is shown.
const majors = {
    "slug": "middlebury-college",
    "read": "2026-10-01",
    "intro": "Every area of study Middlebury offers as a major, from its official Majors and Minors page. Minor-only areas are left out.",
    "groups": [
        {
            "name": "Majors",
            "source": {
                "label": "Middlebury College, Majors and Minors",
                "url": "https://www.middlebury.edu/college/academics/majors-and-minors"
            },
            "majors": [
                {
                    "name": "American Studies",
                    "degree": null
                },
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Arabic",
                    "degree": null
                },
                {
                    "name": "Architectural Studies",
                    "degree": null
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Black Studies",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Chinese",
                    "degree": null
                },
                {
                    "name": "Classical Studies",
                    "degree": null
                },
                {
                    "name": "Classics",
                    "degree": null
                },
                {
                    "name": "Comparative Literature",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Dance",
                    "degree": null
                },
                {
                    "name": "Earth and Climate Sciences",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Education Studies",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Environmental Studies",
                    "degree": null
                },
                {
                    "name": "Film and Media Culture",
                    "degree": null
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": null
                },
                {
                    "name": "Gender, Sexuality, and Feminist Studies",
                    "degree": null
                },
                {
                    "name": "Geography",
                    "degree": null
                },
                {
                    "name": "German",
                    "degree": null
                },
                {
                    "name": "History of Art and Museum Studies",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "Independent Scholar",
                    "degree": null
                },
                {
                    "name": "International and Global Studies",
                    "degree": null
                },
                {
                    "name": "International Politics and Economics",
                    "degree": null
                },
                {
                    "name": "Italian",
                    "degree": null
                },
                {
                    "name": "Japanese Studies",
                    "degree": null
                },
                {
                    "name": "Literary Studies",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Molecular Biology and Biochemistry",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Neuroscience",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Religion",
                    "degree": null
                },
                {
                    "name": "Russian",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Spanish",
                    "degree": null
                },
                {
                    "name": "Statistics",
                    "degree": null
                },
                {
                    "name": "Studio Art",
                    "degree": null
                },
                {
                    "name": "Theatre",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
